export function convertStrToDate(str: string): Date {
    const res = new Date(str);

    return res;
}
